import {
  reportLevelOptions,
  MAX_LENGTH_OF_ADD_JOB_INPUT,
  MIN_LENGTH_OF_ADD_JOB_SEARCH,
} from '../../constants/globalFormValues';

export const formSections = translations => [
  {
    key: 'basicInformation',
    label: translations.basicInformation.title,
    fields: [
      {
        key: 'equipmentSerialNumber',
        label: translations.basicInformation.fieldLabels.equipmentSerialNumber,
        type: 'input',
        control: 'alphanumeric',
        required: true,
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'serviceTechnologyCenterPlannerGroup',
        label: translations.basicInformation.fieldLabels.serviceTechnologyCenter,
        type: 'select',
        options: getCenterOptions('serviceTechnologyCenters', true),
        apiEndpoint: '/api/jobs/map/stc-job-types/',
        updateValueFor: 'reset materialNumberSearch',
        required: true,
      },
      {
        key: 'customerCenterPlantCode',
        label: translations.basicInformation.fieldLabels.customerCenter,
        type: 'select',
        options: getCenterOptions('customerCenters'),
        required: true,
      },
      {
        key: 'reportLevel',
        label: translations.basicInformation.fieldLabels.reportLevel,
        type: 'select',
        apiEndpoint: 'api/jobs/initial-warranty-codes',
        options: reportLevelOptions,
        required: true,
      },
      {
        key: 'initialWarrantyCode',
        label: translations.basicInformation.fieldLabels.initialWarrantyCode,
        type: 'select',
        condition: 'reportLevel > 1',
        required: true,
      },
      {
        key: 'customerPurchaseOrderNumber',
        label: translations.basicInformation.fieldLabels.customerPurchaseOrderNumber,
        type: 'input',
        control: 'text',
        required: true,
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'responsibleSalesPerson',
        label: translations.basicInformation.fieldLabels.responsibleSalesPerson,
        type: 'input',
        control: 'text',
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'customerCenterContactName',
        label: translations.basicInformation.fieldLabels.customerCenterContactName,
        type: 'input',
        control: 'text',
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'customerCenterContactEmail',
        label: translations.basicInformation.fieldLabels.customerCenterContactEmail,
        type: 'input',
        control: 'email',
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      }
    ],
  },
  {
    key: 'jobType',
    label: translations.jobType.title,
    fields: [
      {
        key: 'jobType',
        label: translations.jobType.fieldLabels.jobType,
        type: 'select',
        options: [],
        updateValueFor: 'jobTypeDescription',
      },
      {
        key: 'jobTypeDescription',
        label: translations.jobType.fieldLabels.jobTypeDescription,
        type: 'textarea',
        control: 'text',
        auto: 'jobType',
        condition: 'jobType',
      },
    ],
  },
  {
    key: 'materialNumber',
    label: translations.materialNumber.title,
    fields: [
      {
        key: 'materialNumberSearch',
        label: translations.searchMaterialNumber,
        type: 'search',
        control: 'alphanumeric',
        apiEndpoint: '/api/jobs/map/stc-material-numbers/',
        additionalParameter: 'serviceTechnologyCenterPlannerGroup',
        condition: 'serviceTechnologyCenterPlannerGroup',
        minLength: MIN_LENGTH_OF_ADD_JOB_SEARCH,
      },
      {
        key: 'materialNumber',
        label: translations.materialNumber.fieldLabels.materialNumber,
        type: 'select',
        options: [],
        optionsFrom: 'materialNumberSearch',
        apiEndpoint: '/api/jobs/map/code-groups/',
        additionalParameter: 'serviceTechnologyCenterPlannerGroup',
        condition: 'serviceTechnologyCenterPlannerGroup && materialNumberSearch',
        updateValueFor: 'materialDescription',
        alwaysShow: true,
        required: true,
      },
      {
        key: 'materialDescription',
        label: translations.materialNumber.fieldLabels.materialNumberDescription,
        type: 'textarea',
        control: 'text',
        auto: 'materialNumber',
        condition: 'materialNumber',
      },
    ],
  },
  {
    key: 'serviceProductNumber',
    label: translations.serviceProductNumber.title,
    fields: [
      {
        key: 'serviceProductNumber',
        label: translations.serviceProductNumber.fieldLabels.serviceProductNumber,
        type: 'input',
        control: 'text',
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'serviceProductDescription',
        label: translations.serviceProductNumber.fieldLabels.serviceProductNumberDescription,
        type: 'textarea',
        control: 'text',
      },
    ],
  },
  {
    label: translations.symptomCode.title,
    key: 'symptomCode',
    fields: [
      {
        key: 'scGroups',
        label: translations.symptomCode.fieldLabels.scGroups,
        type: 'select',
        options: [],
        apiEndpoint: '/api/jobs/map/sc-codes/',
        required: 'materialNumber',
        condition: 'materialNumber',
        optionsFrom: 'materialNumber',
        alwaysShow: true,
      },
      {
        key: 'symptomCode',
        label: translations.symptomCode.fieldLabels.symptomCode,
        type: 'select',
        options: [],
        optionsFrom: 'scGroups',
        required: 'scGroups',
        condition: 'materialNumber && scGroups',
        alwaysShow: true,
      },
    ],
  },
  {
    key: 'faultCode',
    label: translations.faultCode.title,
    fields: [
      {
        key: 'fcGroups',
        label: translations.faultCode.fieldLabels.fcGroups,
        type: 'select',
        options: [],
        optionsFrom: 'materialNumber',
        apiEndpoint: '/api/jobs/map/fc-codes/',
        required: 'materialNumber',
        condition: 'materialNumber',
        alwaysShow: true,
      },
      {
        key: 'faultCode',
        label: translations.faultCode.fieldLabels.faultCode,
        type: 'select',
        options: [],
        optionsFrom: 'fcGroups',
        required: 'fcGroups',
        condition: 'materialNumber && fcGroups',
        alwaysShow: true,
      },
    ],
  },
  {
    key: 'customerInformation',
    label: translations.customerInformation.title,
    fields: [
      {
        key: 'customerNumber',
        label: translations.customerInformation.fieldLabels.customerId,
        type: 'input',
        control: 'number',
        required: true,
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'customerName',
        label: translations.customerInformation.fieldLabels.customerName,
        type: 'input',
        control: 'text',
        required: true,
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'customerAddress',
        label: translations.customerInformation.fieldLabels.customerAddress,
        type: 'input',
        control: 'text',
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'customerContactPerson',
        label: translations.customerInformation.fieldLabels.customerContact,
        type: 'input',
        control: 'text',
        maxLength: MAX_LENGTH_OF_ADD_JOB_INPUT,
      },
      {
        key: 'customerContactEmail',
        label: translations.customerInformation.fieldLabels.customerEmail,
        type: 'input',
        control: 'email',
      },
      {
        key: 'customerContactPhoneNumber',
        label: translations.customerInformation.fieldLabels.customerPhone,
        type: 'input',
        control: 'tel',
      },
    ],
  },
];

const getCenterOptions = (centerType, shouldCheckForSAP = false) => {
  let userCenters = localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))[centerType];

  // When adding a job, we must remove all STCs which are connected to SAP
  if (userCenters && userCenters.length) {
    if (shouldCheckForSAP) {
      userCenters = userCenters.filter(center => !center.connectedToSAP)
    }

    return userCenters.reduce((acc, center) => {
      return [...acc, {value: center.code, label: center.name}]
    }, [])
  }

  return [];
};



// WEBPACK FOOTER //
// ./src/views/AddJob/constants.js